import type { MomentInput } from 'moment';
import moment from 'moment';
import type { AxisLabelsFormatterContextObject } from 'highcharts';

function endOfTheYearFormatter(this: AxisLabelsFormatterContextObject) {
  const { dataMin, dataMax, tickPositions } = this.axis;
  const min = moment.utc(dataMin ?? undefined);
  const max = moment.utc(dataMax ?? undefined);
  const yearsDiff = max.diff(min, 'years');

  if (yearsDiff > 0) {
    return moment.utc(this.value).format("MMM. 'YY");
  }

  const previousTick = tickPositions?.[tickPositions.indexOf(this.value) - 1];
  const currentDate = alignDates(this.value);
  const previousDate = previousTick ? alignDates(previousTick) : currentDate;
  const isSameYearAsBefore = previousDate.isSame(currentDate, 'year');

  return currentDate.format(`MMM. D${isSameYearAsBefore ? '' : " 'YY"}`);
}

/**
 * For non-daily frequency, we have the issue with mismatch of the month of the returns with the month on the
 * x-axis. That's because the returns for a specific month are timestamped at the last millisecond of that
 * month, and the tick on the x-axis for a specific month is timestamped at the first millisecond of that month.
 * This causes the situation where you hover over a point that's almost directly above "March", and the tooltip
 * says it's data for "February". In reality, these two differ by 1 millisecond (but one that makes a difference
 * between February and March). To fix this, we change the date to the end of the previous day, so it should
 * be aligned with our return dates.
 *
 * An analogical explanation goes for daily frequency with x-axis labels in day-month format.
 */
function alignDates(value: MomentInput) {
  return moment.utc(value).subtract(1, 'd').endOf('day');
}

export default { endOfTheYearFormatter, alignDates };
